import React from 'react';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import UserCard from 'components/Cards/UserCard/UserCard';
import FinancialAdvLogo from '../../../assets/images/FinancialAdvLogo.png';
import LegalAdvLogo from '../../../assets/images/LegalAdvLogo.png';
import PraexoSupportLogo from '../../../assets/images/PraexoSupportLogo.png';
// avatars
import AvatarJonathan from '../../../assets/avatars/fakePersons/AvatarJonathan.png';
import AvatarElwin from '../../../assets/avatars/fakePersons/AvatarElwin.png';
import AvatarFaadi from '../../../assets/avatars/fakePersons/AvatarFaadi.png';
import AvatarKyrillos from '../../../assets/avatars/fakePersons/AvatarKyrillos.png';
import AvatarLelio from '../../../assets/avatars/fakePersons/AvatarLelio.png';
import AvatarOka from '../../../assets/avatars/fakePersons/AvatarOka.png';
import AvatarRajendra from '../../../assets/avatars/fakePersons/AvatarRajendra.png';
import AvatarSlavcho from '../../../assets/avatars/fakePersons/AvatarSlavcho.png';
import AvatarWalter from '../../../assets/avatars/fakePersons/AvatarWalter.png';

const useStyles = makeStyles((theme) => ({
  container: {
    width: '100%'
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    margin: '35px 0',

    '& h4': {
      fontSize: 18,
      fontWeight: 'bold',
      marginLeft: 10
    }
  },
  cardContainer: {
    display: 'flex',
    alignItems: 'center',
    margin: '20px auto'
  },
  legalCardContainer: {
    display: 'flex',
    alignItems: 'center',
    marginTop: 35
  },
  imgTitle: {
    display: 'flex',
    alignItems: 'center'
  },
  exportButton: {
    fontSize: '16px',
    textTransform: 'Capitalize',
    fontWeight: 'bold',
    borderColor: '#002380',
    borderRadius: 0,
    marginRight: '1rem',
    minWidth: '145px'
  }
}));

const companyMembers = [
  {
    name: 'Jonathan Wood',
    status: 'CEO',
    phone: '+33 6 56 42 67 02',
    email: 'jonathan.wood@email.com',
    avatar: AvatarJonathan
  },
  {
    name: 'Elwin Sharvill',
    status: 'CFO',
    phone: '+33 6 43 95 11 03',
    email: 'elwin.sharvill@email.com',
    avatar: AvatarElwin
  },
  {
    name: 'Oka Tomoaki',
    status: 'Corporate Finance',
    phone: '+33 6 13 95 32 99',
    email: 'oka.tomoaki@email.com',
    avatar: AvatarOka
  }
];

const financialAdvisors = [
  {
    name: 'Faadi Al Rahman',
    status: 'Lead Financial Advisor',
    phone: '+33 6 00 19 38 11',
    email: 'faadi.al.rahman@email.com',
    avatar: AvatarFaadi
  },
  {
    name: 'Walter Noor',
    status: 'Financial Advisor',
    phone: '+33 6 12 65 96 33',
    email: 'walter.noor@email.com',
    avatar: AvatarWalter
  },
  {
    name: 'Rajendra Celino',
    status: 'Financial Advisor',
    phone: '+33 6 09 85 72 33',
    email: 'rajendra.celino@email.com',
    avatar: AvatarRajendra
  }
];

const legalAdvisors = [
  {
    name: 'Lelio Nimrod',
    status: 'Lead Legal Advisor',
    phone: '+33 6 00 19 38 11',
    email: 'lelio.nimrod@email.com',
    avatar: AvatarLelio
  },
  {
    name: 'Kyrillos Chatzkel',
    status: 'Legal Advisor',
    phone: '+33 6 12 65 96 33',
    email: 'kyrillos.chatzkel@email.com',
    avatar: AvatarKyrillos
  }
];

const supportIt = {
  name: 'Slavcho Karbashewski',
  status: 'Advisor',
  phone: '+33 6 56 01 94 22',
  email: 'slavcho.karbashewski@email.com',
  avatar: AvatarSlavcho
};

const Team = (props) => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <div className={classes.header}>
        <h4>Company members</h4>
        <Button
          className={classes.exportButton}
          color="primary"
          variant="outlined">
          export contacts
        </Button>
      </div>
      <div className={classes.cardContainer}>
        {companyMembers.map(({ name, email, phone, status, avatar }) => (
          <UserCard
            avatar={avatar}
            email={email}
            name={name}
            phone={phone}
            status={status}
          />
        ))}
      </div>
      <div className={classes.header}>
        <div className={classes.imgTitle}>
          <img alt="financial-adv-logo" src={FinancialAdvLogo} width="13%" />
          <h4>Financial advisor: Praexo</h4>
        </div>
      </div>
      <div className={classes.cardContainer}>
        {financialAdvisors.map(({ name, email, phone, status, avatar }) => (
          <UserCard
            avatar={avatar}
            email={email}
            name={name}
            phone={phone}
            status={status}
          />
        ))}
      </div>
      <div className={classes.header}>
        <div className={classes.imgTitle}>
          <img alt="financial-adv-logo" src={LegalAdvLogo} width="13%" />
          <h4>Legal Advisor: Jones Day</h4>
        </div>
      </div>
      <div className={classes.legalCardContainer}>
        {legalAdvisors.map(({ name, email, phone, status, avatar }) => (
          <UserCard
            avatar={avatar}
            email={email}
            name={name}
            phone={phone}
            status={status}
          />
        ))}
      </div>
      <div className={classes.header}>
        <div className={classes.imgTitle}>
          <img alt="financial-adv-logo" src={PraexoSupportLogo} width="13%" />
          <h4>PraeXo IT Support</h4>
        </div>
      </div>
      <div className={classes.cardContainer}>
        <UserCard
          avatar={supportIt.avatar}
          email={supportIt.email}
          name={supportIt.name}
          phone={supportIt.phone}
          status={supportIt.status}
        />
      </div>
    </div>
  );
};

export default withRouter(Team);
